import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "er-drawer__head" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-start gap-3" }
const _hoisted_4 = { class: "fs-3 fw-bolder m-0 text-gray-900" }
const _hoisted_5 = { class: "fs-8 text-gray-500 fw-bold mt-1" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "er-stats" }
const _hoisted_9 = { class: "er-stat" }
const _hoisted_10 = { class: "er-num" }
const _hoisted_11 = { class: "er-stat" }
const _hoisted_12 = { class: "er-num" }
const _hoisted_13 = { class: "er-stat" }
const _hoisted_14 = { class: "er-drawer__body" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "er-sec" }
const _hoisted_18 = { class: "er-spark" }
const _hoisted_19 = { class: "er-sec" }
const _hoisted_20 = {
  key: 0,
  class: "er-empty"
}
const _hoisted_21 = {
  key: 1,
  class: "er-dl"
}
const _hoisted_22 = { class: "er-num" }
const _hoisted_23 = { class: "er-num" }
const _hoisted_24 = {
  key: 2,
  class: "er-empty"
}
const _hoisted_25 = { class: "er-sec" }
const _hoisted_26 = {
  key: 0,
  class: "er-empty"
}
const _hoisted_27 = { class: "er-dl" }
const _hoisted_28 = { class: "er-num" }
const _hoisted_29 = { class: "er-num" }
const _hoisted_30 = {
  key: 0,
  class: "er-flagnote"
}
const _hoisted_31 = {
  key: 2,
  class: "er-empty"
}
const _hoisted_32 = { class: "er-sec" }
const _hoisted_33 = { class: "er-dl" }
const _hoisted_34 = { class: "er-drawer__foot" }
const _hoisted_35 = {
  key: 0,
  class: "er-reasons"
}
const _hoisted_36 = {
  key: 0,
  class: "er-empty"
}
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 1,
  class: "er-adj"
}
const _hoisted_39 = { class: "fw-bold text-gray-700" }
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = {
  key: 1,
  class: "er-reasons"
}
const _hoisted_42 = {
  key: 0,
  class: "er-reason"
}
const _hoisted_43 = {
  key: 1,
  class: "er-adj"
}
const _hoisted_44 = { class: "fw-bold text-gray-700" }
const _hoisted_45 = { class: "fs-8 text-gray-500" }
const _hoisted_46 = {
  key: 2,
  class: "d-flex gap-3"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["er-scrim", { 'is-on': _ctx.open }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, null, 2),
    _createElementVNode("aside", {
      class: _normalizeClass(["er-drawer", { 'is-on': _ctx.open }]),
      "aria-hidden": !_ctx.open
    }, [
      (_ctx.row)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.isArabic ? _ctx.row.titleAr : _ctx.row.titleEn), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.isArabic ? _ctx.row.titleEn : _ctx.row.titleAr) + " · " + _toDisplayString(_ctx.translate('expertReviewClusterLabel', {
                  cluster: _ctx.row.clusterId,
                })) + " · " + _toDisplayString(_ctx.quarterLabel), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-icon btn-sm btn-active-light-primary",
                  "aria-label": _ctx.translate('expertReviewClose'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                  ])
                ], 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.translate('expertReviewNewValue')), 1),
                  _createElementVNode("b", _hoisted_10, _toDisplayString(_ctx.fmt(_ctx.livePrice(_ctx.row))), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.translate('expertReviewLastApproved')), 1),
                  _createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.fmt(_ctx.row.previousPricePerSqm)), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.translate('expertReviewChange')), 1),
                  _createElementVNode("b", {
                    class: _normalizeClass(["er-num", _ctx.deltaClass(_ctx.liveQoq(_ctx.row))])
                  }, _toDisplayString(_ctx.pct(_ctx.liveQoq(_ctx.row))), 3)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.row.isThinCluster || _ctx.isCarried)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["er-note", { 'er-note--bad': _ctx.isCarried }])
                  }, [
                    (_ctx.isCarried)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('expertReviewCarriedNote')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.row.isThinCluster)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.translate('expertReviewThinNote', {
                count: _ctx.row.clusterDealsCount,
                threshold: _ctx.quarter.thinClusterThreshold,
              })), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.translate('expertReviewPricePath')), 1),
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bars, (height, index) => {
                    return (_openBlock(), _createElementBlock("i", {
                      key: index,
                      class: _normalizeClass({ 'is-last': index === _ctx.bars.length - 1 }),
                      style: _normalizeStyle({ height: height + '%' })
                    }, null, 6))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.translate('expertReviewDealsInArea', {
                area: _ctx.isArabic ? _ctx.row.titleAr : _ctx.row.titleEn,
                count: _ctx.row.dealsCount,
              })), 1),
                (!_ctx.detailsReady)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.translate(
                _ctx.detailsFailed
                  ? 'expertReviewEvidenceFailed'
                  : 'expertReviewEvidenceLoading'
              )), 1))
                  : (_ctx.row.deals.length)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_21, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColType')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColSize')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColPricePerSqm')), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.deals, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.translate(_ctx.propertyTypeKey(item.propertyType))), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(item.sizeSqm), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.fmt(item.pricePerSqm)), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.translate('expertReviewNoOwnDeals')), 1))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.translate('expertReviewDealsInCluster', {
                cluster: _ctx.row.clusterId,
                count: _ctx.row.clusterDealsCount,
              })), 1),
                (!_ctx.detailsReady)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.translate(
                _ctx.detailsFailed
                  ? 'expertReviewEvidenceFailed'
                  : 'expertReviewEvidenceLoading'
              )), 1))
                  : (_ctx.clusterDeals.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("table", _hoisted_27, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColArea')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColType')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColSize')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.translate('expertReviewColPricePerSqm')), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusterDeals, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: _normalizeClass({
                  'is-out': item.pricePerSqm === _ctx.outlierPrice,
                  'is-self': item.areaTitleEn === _ctx.row.titleEn,
                })
                            }, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.isArabic ? item.areaTitleAr : item.areaTitleEn) + _toDisplayString(item.areaTitleEn === _ctx.row.titleEn ? ' ·' : ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.translate(_ctx.propertyTypeKey(item.propertyType))), 1),
                              _createElementVNode("td", _hoisted_28, _toDisplayString(item.sizeSqm), 1),
                              _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.fmt(item.pricePerSqm)), 1)
                            ], 2))
                          }), 128))
                        ]),
                        (_ctx.showOutlierNote)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.translate('expertReviewClusterFlagNote')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.translate('expertReviewNoClusterDeals')), 1))
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.translate('expertReviewReading')), 1),
                _createElementVNode("table", _hoisted_33, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.translate('expertReviewEvidenceTag')), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", 
                    _ctx.row.evidence === 'OBSERVED'
                      ? 'badge-light'
                      : _ctx.row.evidence === 'MIXED'
                      ? 'badge-light-warning'
                      : 'badge-light-danger'
                  ])
                      }, _toDisplayString(_ctx.translate('expertReviewEvidence' + _ctx.row.evidence)), 3)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.translate('expertReviewQuarterStatus')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.row.isFinal
                    ? _ctx.translate('expertReviewQuarterStatusFinal')
                    : _ctx.translate('expertReviewQuarterStatusProvisional', {
                        percent: _ctx.quarter.elapsedPercentage,
                      })), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.translate('expertReviewYearOnYear')), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(["er-num", _ctx.deltaClass(_ctx.row.yoyChange)])
                    }, _toDisplayString(_ctx.pct(_ctx.row.yoyChange)), 3)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.translate('expertReviewIfRejected')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.row.isFinal
                    ? _ctx.translate('expertReviewIfRejectedFinal')
                    : _ctx.translate('expertReviewIfRejectedProvisional', {
                        value: _ctx.fmt(_ctx.row.previousPricePerSqm),
                      })), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_ctx.showReasons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (!_ctx.reasonsReady)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.translate(
                _ctx.reasonsFailed
                  ? 'expertReviewReasonsFailed'
                  : 'expertReviewReasonsLoading'
              )), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reason) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: reason.id,
                        class: "er-reason"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedReason) = $event)),
                          type: "radio",
                          class: "form-check-input me-3",
                          name: "er-reason",
                          value: reason.id
                        }, null, 8, _hoisted_37), [
                          [_vModelRadio, _ctx.selectedReason]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.isArabic ? reason.nameAr : reason.nameEn), 1)
                      ]))
                    }), 128)),
                    (_ctx.needsNote)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('expertReviewNote')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.note) = $event)),
                            type: "text",
                            class: "form-control form-control-sm flex-grow-1",
                            placeholder: _ctx.translate('expertReviewNotePlaceholder')
                          }, null, 8, _hoisted_40), [
                            [_vModelText, _ctx.note]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.row.status === 'PENDING' && _ctx.canUpdate && _ctx.detailsReady)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (!(_ctx.row.isFinal && _ctx.showReasons))
                      ? (_openBlock(), _createElementBlock("label", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adjusting) = $event)),
                            type: "checkbox",
                            class: "form-check-input me-3"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.adjusting]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.translate('expertReviewAdjustPrice')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.adjusting)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate('expertReviewYourValue')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.expertValue) = $event)),
                            type: "number",
                            class: "form-control form-control-sm er-num w-150px"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.expertValue,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.translate('expertReviewPricePerSqmUnit')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.row.status === 'PENDING' && _ctx.canUpdate && _ctx.detailsReady)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success flex-grow-1",
                      disabled: _ctx.adjusting && !_ctx.hasExpertValue,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('approve', _ctx.adjusting ? Number(_ctx.expertValue) : null)))
                    }, _toDisplayString(_ctx.translate('expertReviewApproveAndPublish', {
                value: _ctx.fmt(_ctx.adjusting ? _ctx.expertValue : _ctx.row.pricePerSqm),
              })), 9, _hoisted_47),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light-danger flex-grow-1",
                      disabled: _ctx.showReasons && !_ctx.reasonsReady,
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onReject && _ctx.onReject(...args)))
                    }, _toDisplayString(_ctx.showReasons
                ? _ctx.translate('expertReviewConfirmRejection')
                : _ctx.translate('expertReviewReject')), 9, _hoisted_48)
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "btn btn-light w-100",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
                  }, _toDisplayString(_ctx.translate('expertReviewClose')), 1))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ], 64))
}